import { render, staticRenderFns } from "./product.vue?vue&type=template&id=f58d1f30&scoped=true"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"
import style0 from "./product.vue?vue&type=style&index=0&id=f58d1f30&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f58d1f30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\newWarehouse\\qmsk-platform-supply-merchant-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f58d1f30')) {
      api.createRecord('f58d1f30', component.options)
    } else {
      api.reload('f58d1f30', component.options)
    }
    module.hot.accept("./product.vue?vue&type=template&id=f58d1f30&scoped=true", function () {
      api.rerender('f58d1f30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jhyc/service/product.vue"
export default component.exports